export default __webpack_public_path__ + "static/media/icon-facebook-white.86df236e.svg";